import { WithDefaults } from '@stl/urql';
import router from '@/router';

export const urqlOptions = WithDefaults(
  {
    keys: {
      UserRole: () => null
    },
    updates: {
      Mutation: {
        deleteRegistration(result, args, cache) {
          if (!result.deleteRegistration) {
            return;
          }
          cache.invalidate({ __typename: 'DeviceRegistration', id: args.registrationId as number });
        },
        assignDevice(result, _args, cache) {
          if (!result.assignDevice) {
            return;
          }
          cache
            .inspectFields('Query')
            .filter((field) => field.fieldName === 'deviceRegistrations')
            .forEach((field) => cache.invalidate('Query', field.fieldName, field.arguments));
        },
        registerDevice(result, _args, cache) {
          if (!result.registerDevice) {
            return;
          }
          cache
            .inspectFields('Query')
            .filter((field) => field.fieldName === 'deviceRegistrations')
            .forEach((field) => cache.invalidate('Query', field.fieldName, field.arguments));
        }
      }
    }
  },
  {
    mapExchange: {
      onError: (error) => {
        if (error.response?.status === 401) {
          let currentPath = router.currentRoute.value.fullPath;
          if (!/^\/(login|logout|$)/.test(currentPath)) {
            if (currentPath.length == 0 || currentPath[0] !== '/') {
              currentPath = '/' + currentPath;
            }
            const query = `?redirect_uri=${window.location.protocol}//${window.location.hostname}${currentPath}`;
            window.location.assign('/login' + query);
          }
        }
      }
    }
  }
);
